module.exports = __webpack_public_path__ + "static/img/banner_solutions_professional.72458b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/banner_solutions_professional.png
// module id = qUWZ
// module chunks = 10